/*
 * 文件下载工具
 *
 * 抽成共享模块，供 FileListBlock（普通导出卡）和 FilePreviewCard（富预览卡）复用，
 * 避免两处各维护一份下载逻辑。
 */

/**
 * 拉取文件并触发浏览器下载。
 * 优先走 fetch → blob → a[download] 拿到原文件名；失败兜底新窗口打开 url。
 *
 * @param url - 文件地址
 * @param name - 下载保存的文件名（含扩展名）
 *
 * @example
 * ```ts
 * await downloadFile('https://oss/x.xlsx', '本月台账.xlsx')
 * ```
 */
export async function downloadFile(url: string, name: string): Promise<void> {
  try {
    const res = await fetch(url, { credentials: 'include' })
    const blob = await res.blob()
    const blobUrl = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = blobUrl
    a.download = name
    a.click()
    URL.revokeObjectURL(blobUrl)
  } catch {
    window.open(url, '_blank')
  }
}
